/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SearchField } from '@opengeoweb/shared';
import { timeSeriesActions } from '../../store';
import { getSearchFilter } from '../../store/selectors';
import type { TimeSeriesRootState } from '../../store/types';
import { useTimeseriesTranslation } from '../../utils/i18n';

interface SearchFieldConnectProps {
  panelId: string;
}

const SearchFieldConnect: React.FC<SearchFieldConnectProps> = ({
  panelId,
}: SearchFieldConnectProps) => {
  const dispatch = useDispatch();
  const { t } = useTimeseriesTranslation();

  const searchFilter = useSelector((state: TimeSeriesRootState) =>
    getSearchFilter(state, panelId),
  );

  const toggleServicePopup = (url: string): void => {
    dispatch(
      timeSeriesActions.setServicePopup({
        panelId,
        isOpen: true,
        url,
        variant: 'save',
      }),
    );
  };

  const setSearchFilter = (filterText: string): void => {
    dispatch(timeSeriesActions.setSearchFilter({ filterText, panelId }));
  };

  return (
    <SearchField
      label={t('timeseries-search-ts-or-enter-url')}
      onOpenServicePopup={toggleServicePopup}
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
    />
  );
};

export default SearchFieldConnect;
